interface IconProps {
  ariaLabel?: string
}

const defaultProps: Partial<IconProps> = {
  ariaLabel: '',
}

export const PlayIcon: React.FC<IconProps> = ({ariaLabel} = defaultProps) => {
  return (
    <svg
      aria-label={ariaLabel}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.24905 3.69194C5.82218 3.45967 5.30225 3.76868 5.30225 4.25466V15.7452C5.30225 16.2312 5.82218 16.5402 6.24906 16.3079L16.8079 10.5626C17.2538 10.32 17.2538 9.67983 16.8079 9.4372L6.24905 3.69194ZM4.021 4.25466C4.021 2.79672 5.58078 1.86969 6.86142 2.56651L17.4203 8.31176C18.758 9.03966 18.758 10.9602 17.4203 11.6881L6.86143 17.4333C5.58079 18.1301 4.021 17.2031 4.021 15.7452V4.25466Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const PauseIcon: React.FC<IconProps> = ({ariaLabel} = defaultProps) => {
  return (
    <svg
      aria-label={ariaLabel}
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.15812 2.3125C4.33257 2.3125 3.66333 2.98174 3.66333 3.80729V16.1927C3.66333 17.0183 4.33257 17.6875 5.15812 17.6875H8.1477C8.97326 17.6875 9.6425 17.0183 9.6425 16.1927V3.80729C9.6425 2.98174 8.97326 2.3125 8.1477 2.3125H5.15812ZM4.94458 3.80729C4.94458 3.68936 5.04019 3.59375 5.15812 3.59375H8.1477C8.26564 3.59375 8.36125 3.68936 8.36125 3.80729V16.1927C8.36125 16.3106 8.26564 16.4062 8.1477 16.4062H5.15812C5.04019 16.4062 4.94458 16.3106 4.94458 16.1927V3.80729ZM12.8456 2.3125C12.0201 2.3125 11.3508 2.98174 11.3508 3.80729V16.1927C11.3508 17.0183 12.0201 17.6875 12.8456 17.6875H15.8352C16.6608 17.6875 17.33 17.0183 17.33 16.1927V3.80729C17.33 2.98174 16.6608 2.3125 15.8352 2.3125H12.8456ZM12.6321 3.80729C12.6321 3.68936 12.7277 3.59375 12.8456 3.59375H15.8352C15.9531 3.59375 16.0487 3.68936 16.0487 3.80729V16.1927C16.0487 16.3106 15.9531 16.4062 15.8352 16.4062H12.8456C12.7277 16.4062 12.6321 16.3106 12.6321 16.1927V3.80729Z"
        fill="currentColor"
      />
    </svg>
  )
}

try{ PlayIcon.displayName ||= 'PlayIcon' } catch {}
try{ PauseIcon.displayName ||= 'PauseIcon' } catch {}